import { addHours, format, setMinutes } from "date-fns";
import { useId } from "react";



export const HorizontalLines = ({
  hours,
  numberOfGridStopsPerCell,
  containerOffsetRef,
}) => {
  const  timeFormat  = 'h:mm a';
  // We need to force the minute to zero, because otherwise in ex GMT+5.5, it would show :30 minute times (but at the positino of :00)
  const lastHour = hours[hours.length - 1];
const finalHour = format(
  setMinutes(addHours(lastHour, 1), 0),
  timeFormat
);
  const id = useId();

  return (
    <div
      className=" divide-default pointer-events-none relative z-[60] col-start-1 col-end-2 row-start-1 grid divide-y"
      style={{
        gridTemplateRows: `repeat(${hours.length}, minmax(var(--gridDefaultSize),1fr)`,
      }}>
      <div className="row-end-1 h-[--calendar-offset-top] " ref={containerOffsetRef} />
      {hours.map((hour) => (
        <div key={`${id}-${format(hour, timeFormat)}`}>
          <div className="text-black sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-[10px] leading-5 ">
            {/* We need to force the minute to zero, because otherwise in ex GMT+5.5, it would show :30 minute times (but at the positino of :00) */}
            {format(setMinutes(hour, 0), timeFormat)}
          </div>
        </div>
      ))}
      <div key={`${id}-${finalHour}`}>
        <div className="text-black sticky left-0 z-20 -ml-14 -mt-2.5 w-14 pr-2 text-right text-[10px] leading-5 ">
          {finalHour}
        </div>
      </div>
    </div>
  );
};
